/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class DeliveryDiscount extends React.PureComponent {
  render() {
    const { onChange, value } = this.props

    return (
      <Form.Field required>
        <label>Delivery Discount</label>
        <Input
          label={{ content: '$' }}
          labelPosition="right"
          placeholder="e.g 1"
          type="number"
          required
          min={0}
          step={0.01}
          max={100}
          value={value}
          onChange={e => onChange(e.target.value)}
        />
      </Form.Field>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/deliveryFeeOffer/fields/deliveryDiscountField.js